{
  "feeCalculator": {
    "sections": {
      "inputs": "Entrées",
      "calculations": "Calculs"
    },
    "tabs": {
      "tenantAndTransient": "Frais résidents et visiteurs",
      "annualFees": "Frais annuels"
    },
    "rateLabels": {
      "default": "Par défaut"
    },
    "inputs": {
      "aircraft": {
        "title": "Aéronef",
        "subtitle": "Aéronef pour lequel vous souhaitez calculer les redevances. Nous utiliserons l'envergure et la longueur pour calculer la surface utilisée dans les calculs.",
        "makeModel": "Marque/Modèle",
        "dimensions": "Dimensions"
      },
      "buffer": {
        "title": "Tampon",
        "subtitle": "Une marge est ajoutée à chaque extrémité des dimensions. Ex : une marge de 2{{unit}} ajoute un total de 4{{unit}} à la longueur et 4{{unit}} à l'envergure."
      },
      "baseTenantRate": {
        "title": "Tarif de base locataire",
        "subtitle": "Taux utilisé pour calculer la tarification mensuelle des locataires.",
        "label": "$ / m²{{unit}} / mois"
      },
      "transientRate": {
        "title": "Tarif passage",
        "subtitle": "Tarif à utiliser pour le calcul des prix de stationnement de nuit.",
        "label": "$ / m²{{unit}} / jour"
      },
      "presets": {
        "title": "Modèles",
        "subtitle": "Ajoutez ou modifiez les tarifs prédéfinis dans Paramètres > Estimation.",
        "label": "Tarifs"
      },
      "camFees": {
        "title": "Frais d'entretien des parties communes",
        "subtitle": "Frais d'entretien des parties communes ajoutés au loyer mensuel du locataire. Vous pouvez spécifier un pourcentage ou un montant au {{unit}}².",
        "or": "OU"
      }
    },
    "calculations": {
      "aircraftSquare": "Carré aéronef {{unit}}",
      "aircraftSquareSubtitle": "Surface occupée par l'aéronef. Mesurée en envergure x longueur.",
      "totalSquare": "Total en {{unit}} carrés",
      "totalSquareSubtitle": "Zone occupée par l'aéronef + marge de sécurité (si fournie).",
      "aircraftFee": "Frais aéronef",
      "camFees": "Frais CAM",
      "totalFee": "Frais total",
      "tenantMonthly": "Locataire (mensuel)",
      "transientDaily": "Passage (journalier)"
    }
  }
}
